<template>
    <b-card header-tag="header" footer-tag="footer" class="mt-8">
        <template v-slot:header>
            <p class="mb-0" style="font-size: 21px">Listado de invitaciones</p>
        </template>
        <b-row class="pb-2">
            <b-col cols="12" md="12">
                <div class="text-right">
                    <b-button-group>
                        <b-button variant="info" class="text-white mr-2" @click.prevent="$emit('open-lookup-modal')">
                            <b-icon icon="plus"></b-icon>Nueva Invitación
                        </b-button>

                        <b-button variant="success" class="text-white" @click.prevent="$emit('open-massive-upload-modal')">
                            <b-icon icon="upload"></b-icon> Carga Masiva
                        </b-button>
                    </b-button-group>
                </div>
            </b-col>
        </b-row>
        <b-card-text>
            <b-table 
                responsive
                :fields="fields" 
                striped hover 
                :items="invitations">
                <template v-slot:cell(nombre)="data">
                    {{ data.item.nombre }}
                </template>
                <template v-slot:cell(company_name)="data">
                    {{ data.item.company_name }}
                </template>
                <template v-slot:cell(email)="data">
                    {{ data.item.email }}
                </template>
                <template v-slot:cell(telefono)="data">
                    {{ data.item.telefono }}
                </template>
               <template v-slot:cell(status)="data">
                    <b-badge :variant="statusVariant(data.item.status)">
                        {{ statusLabel(data.item.status) }}
                    </b-badge>
                </template>
                <template v-slot:cell(actions)="{ item }">
                    <b-button 
                        variant="warning" 
                        size="sm"
                        class="mr-1"
                        v-b-tooltip.hover title="Editar Invitación"
                        :disabled="item.status === 'used'"
                        @click.prevent="$emit('go-to-update', item)"
                    >
                        <b-icon icon="pencil" />
                    </b-button>
                    <b-button 
                        variant="info" 
                        size="sm"
                        class="mr-1"
                        v-b-tooltip.hover title="Reenviar Invitación"
                        :disabled="item.status === 'used'"
                        @click.prevent="$emit('resend-invitation', item.id)"
                    >
                        <b-icon icon="envelope" />
                    </b-button>

                    <b-button 
                        variant="danger" 
                        size="sm"
                        v-b-tooltip.hover title="Cancelar Invitación"
                        :disabled="!['pending', 'sent'].includes(item.status)"
                        @click.prevent="$emit('cancel-invitation', item.id)"
                    >
                        <b-icon icon="x-circle" />
                    </b-button>
                </template>
            </b-table>
            <template v-if="invitations.length < 1">
                <b-alert show variant="danger">
                    Lo sentimos, no se han encontrado resultados para su busqueda.
                </b-alert>
            </template>
        </b-card-text>
        <template v-slot:footer>
            <b-row class="tipo-vistas-card justify-content-md-center">
                <b-col cols="12" sm="1">
                    <b-form-select @change="updatePageSize()" v-model="paginator.pageSize" :options="pageSize" ></b-form-select>
                </b-col>                    
                <b-col cols="12" md="4">
                    <b-pagination 
                        size="md" 
                        pills 
                        :total-rows="paginator.totalPage" 
                        v-model="paginator.page" 
                        :per-page="1" 
                        @input="changePage" 
                        first-number 
                        last-number>
                    </b-pagination>
                </b-col>
            </b-row>
        </template>
    </b-card>
</template>

<script>
export default {
    name: "InvitationsTable",
    props: {
        invitations: {
            type: Array
        },
        paginator: {
            type: Object
        },
        pageSize: {
            type: Array
        }
    },
    data(){
        return{
            fields: [
                { key: 'nit', label: 'NIT', sortable: true},
                { key: 'name', label: 'Empresa', sortable: true},
                { key: 'email', label: 'Correo electronico', sortable: true},
                { key: 'status', label: 'Estado', sortable: true},
                { key: 'actions', label: 'Acciones'},
            ],
        }
    },
    methods: {
        updatePageSize(){
            /* the page sizee return the current page to initial because we can't know if the current page have items asigned!! */
            this.paginator.page = 1;
            /* emit the page size update to get the new list of items*/
            this.$emit('get-invitations-list');
        },
        changePage(){
            this.$emit('change-page', this.paginator.page);
        },
        statusVariant(status) {
            const variants = {
                pending:   'warning',
                sent:      'info',
                used:      'success',
                expired:   'secondary',
                cancelled: 'danger'
            };
            return variants[status] || 'light';
        },

        statusLabel(status) {
            const labels = {
                pending:   'Pendiente',
                sent:      'Enviada',
                used:      'Utilizada',
                expired:   'Expirada',
                cancelled: 'Cancelada'
            };
            return labels[status] || status;
        }
    }
};

</script>
<style scoped>

</style>